"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _Mediator = _interopRequireDefault(require("../../../Mediator"));
var _ = _interopRequireDefault(require("../.."));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var InvokeSubMediator = function InvokeSubMediator(props) {
  var completedMessage = props.completedMessage,
    flowList = props.flowList,
    lockedMessage = props.lockedMessage,
    settings = props.settings;
  if (completedMessage) {
    return /*#__PURE__*/_react["default"].createElement("div", null, completedMessage);
  }
  if (lockedMessage) {
    return /*#__PURE__*/_react["default"].createElement("div", null, lockedMessage);
  }
  var SelectedMediator = _Mediator["default"];
  var mediatorProps = !Array.isArray(settings.navigationSettings) ? settings.navigationSettings : {};
  var language = flowList.length ? flowList[0].language : '';
  var currentNavigation = _["default"].find(function (item) {
    return item.handle === settings.navigation;
  });
  if (currentNavigation && currentNavigation.handle !== 'noSidebar') {
    SelectedMediator = currentNavigation.mediatorComponent;
  }
  return /*#__PURE__*/_react["default"].createElement(SelectedMediator
  // onAssignmentComplete already called in useCourseWrapperMediator
  , _extends({}, (0, _omit2["default"])(props, ['onAssignmentComplete', 'onComplete']), {
    allowRetake: settings.allowRetake,
    flowList: flowList,
    language: language,
    mediatorProps: mediatorProps,
    courseWrapperMediatorProps: props.mediatorProps
  }));
};
var _default = InvokeSubMediator;
exports["default"] = _default;